export default __webpack_public_path__ + "static/media/work-system-bg.4ac460db.png";